module.exports = __webpack_public_path__ + "static/media/Fuel Filter.8148eecb.png";